import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import MoleculeModal from '@s-ui/react-molecule-modal'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'

import CardAdModalChildren from './card-ad-modal-children.js'

const CardAdModalFinancingDetails = ({adInfo, handleModal}) => {
  const [financingData, setFinancingData] = useState({
    data: {},
    error: false,
    loading: false
  })
  const {domain, i18n} = useContext(Context)
  const {adId, cashPrice, financedPrice, financingInfo} = adInfo

  const getFinancingInfo = async ({adId, entry, terms}) => {
    const [error, response] = await domain.get('get_financing_data_ads_use_case').execute({adId, entry, terms})

    if (error) {
      setFinancingData({...financingData, error: true})
    } else setFinancingData({...financingData, data: response})
  }

  useMount(() => {
    getFinancingInfo({adId, entry: financingInfo.entry, terms: financingInfo?.terms})
  })

  const isFinancingInfoAvailable = Object.keys(financingData.data).length > 0

  return (
    <>
      {isFinancingInfoAvailable && (
        <MoleculeModal
          isOpen={true}
          closeOnOutsideClick
          closeOnEscKeyDown
          iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
          onClose={() => handleModal(false)}
        >
          <ModalBasicContent
            stepsContent={[
              {
                buttons: {
                  confirmButton: {
                    customCallBack: () => {
                      handleModal(false)
                    },
                    isDisabled: false,
                    text: i18n.t('COMMON.UNDERSTOOD')
                  }
                },
                children: (
                  <CardAdModalChildren
                    financingInfo={{
                      ...financingData.data,
                      cashPrice,
                      financedPrice
                    }}
                    handleModal={handleModal}
                  />
                ),
                title: i18n.t('FINANCING_INFO.OFFER_DETAILS'),
                titleSize: 'xs'
              }
            ]}
          />
        </MoleculeModal>
      )}
    </>
  )
}

CardAdModalFinancingDetails.displayName = 'CardAdModalFinancingDetails'

CardAdModalFinancingDetails.propTypes = {
  adInfo: PropTypes.shape({
    adId: PropTypes.string,
    cashPrice: PropTypes.number,
    financedPrice: PropTypes.number,
    financingInfo: PropTypes.object
  }),
  handleModal: PropTypes.func
}

export default CardAdModalFinancingDetails
